export interface UpdateSystemUserLinkRequest {
  id: string
  title: string
  url: string
  revision: number
}

export function UpdateSystemUserLinkRequestToJSON(
  value: UpdateSystemUserLinkRequest
): any {
  return {
    id: value.id !== '' ? value.id : undefined,
    title: value.title !== '' ? value.title : undefined,
    url: value.url !== '' ? value.url : undefined,
    revision: value.revision !== 0 ? value.revision : undefined
  }
}
